import React, {useState} from 'react';
import {
	Container,
	Row,
	Col,
	Form,
	Button,
	Card,
	InputGroup
} from 'react-bootstrap';
import {FaEquals} from 'react-icons/fa';

const FoedusConversion = () => {
	const [ucatValue, setUcatValue] = useState('');
	const [ulValue, setUlValue] = useState('');

	const convertToUcat = () => {
		if (ucatValue !== '') {
			const newUlValue = parseFloat(ucatValue) * 0.0166;
			setUlValue(newUlValue.toFixed(3));
		}
	};

	const convertToUl = () => {
		if (ulValue !== '') {
			const newUcatValue = parseFloat(ulValue) * 59.99;
			setUcatValue(newUcatValue.toFixed(3));
		}
	};

	const handleUcatChange = (e) => {
		setUcatValue(e.target.value);
	};

	const handleUlChange = (e) => {
		setUlValue(e.target.value);
	};

	const clearInputs = () => {
		setUcatValue('');
		setUlValue('');
	};

	return (
		<Container className='py-4'>
			<Row className='justify-content-center'>
				<Col md={6} className='mt-4'>
					<h4 className='mt-4'>Unit Conversion</h4>
					<Card>
						<Card.Header className='bg-primary text-white'>
							<strong>Gamma-glutamyltransferase (GGT)</strong>
						</Card.Header>
						<Card.Body>
							<InputGroup className='mb-3'>
								<Form.Control
									type='text'
									inputMode='numeric'
									pattern='[0-9]*'
									placeholder='Ul/l'
									value={ucatValue}
									onChange={handleUcatChange}
								/>
								<Button
									variant='primary'
									style={{minWidth: '150px'}}
									onClick={convertToUcat}
								>
									Convert to ucat/L
								</Button>
							</InputGroup>
							<div className='text-center' style={{margin: '10px 0'}}>
								<FaEquals size={20} className='mb-1'/>
							</div>
							<InputGroup className='mb-3'>
								<Form.Control
									type='text'
									inputMode='numeric'
									pattern='[0-9]*'
									placeholder='ucat/L'
									value={ulValue}
									onChange={handleUlChange}
								/>
								<Button
									variant='primary'
									style={{minWidth: '150px'}}
									onClick={convertToUl}
								>
									Convert to Ul/l
								</Button>
							</InputGroup>
							<Button variant='danger' onClick={clearInputs}>
								CLEAR
							</Button>
						</Card.Body>
						<Card.Footer className='bg-light text-muted d-flex justify-content-center align-items-center'>
							<p className='m-0'>1 UI/I = 0.017 ucat/L</p>
						</Card.Footer>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default {
	main: FoedusConversion
};
